import zod from 'zod';

export const imageDataSchema = zod.object({
  filename: zod.string(),
  size: zod.number(),
  lastModified: zod.string(),
  contentType: zod.string().optional(),
  url: zod.string().url(),
});

export const cueingImagesResponseSchema = zod.object({
  images: zod.record(zod.array(imageDataSchema)),
  totalImages: zod.number(),
  totalSize: zod.number(),
});

export type ImageData = zod.infer<typeof imageDataSchema>;
export type CueingImagesResponse = zod.infer<typeof cueingImagesResponseSchema>;
